import { Enquiry } from "@/components/Enquiry";
import { Footer } from "@/components/Footer";
import Header from "@/components/layout/Header";
import * as React from "react";
import ReactDOM from "react-dom";

export const CTA_TEXT = "Start creating";
export const CTA_LINK = "https://app.shorthand.com/signup";
export const DEMO_TEXT = "Get a demo";
export const DEMO_LINK = "https://app.shorthand.com/demo";
export const SIGNIN_TEXT = "Sign in";
export const SIGNIN_LINK = "https://shorthand.com/signin";

const PageLayout = ({ children }: { children: React.ReactNode }) => {
  const [showPortal, setShowPortal] = React.useState(false);
  const portalProps = {
    type: "general-enquiry",
    subject: "general-enquiry",
    onClose: () => setShowPortal(false),
  };

  return (
    <>
      {showPortal && ReactDOM.createPortal(<Enquiry {...portalProps} />, document.getElementById("modal"))}
      <div className="tw-bg-[var(--background-color)] tw-text-[var(--foreground-color)]">
        <Header
          onSalesClick={() => setShowPortal(true)}
          theme="dark-theme"
          linkConfig={{
            ctaText: CTA_TEXT,
            ctaLink: CTA_LINK,
            signInText: SIGNIN_TEXT,
            signInLink: SIGNIN_LINK,
          }}
        />
        <main className="tw-isolate">{children}</main>
        <Footer />
      </div>
    </>
  );
};

export default PageLayout;
